import { useEffect, useState } from "react";
import { Get } from "utils/request";
import { FormLabel, FormControl as Input } from "react-bootstrap";
import DefaultButton from "components/DefaultButton";
import VideoInput from "components/Inputs/VideoInput";
import ImageInput from "components/Inputs/ImageInput";
import { RiArrowGoBackLine } from "react-icons/ri";

const Formbody = (props) => {
  const { OnConfirm, loading } = props;

  const [banner, SetBanner] = useState("");
  const [link, SetLink] = useState("");

  const GetData = async () => {
    let response = await Get(`styles/pages/course_wall_netflix`);
    if (response?.status === true) {
      console.log(response?.data);
      SetBanner(response?.data?.image);
      SetLink(response?.data?.link);
    }
  };

  useEffect(GetData, []);

  return (
    <div className="form-course">
      <form>
        <FormLabel>Imagem</FormLabel>
        <ImageInput path={banner} ImageChange={(image) => SetBanner(image)} />
        <span style={{ color: "#777", display: "block", marginTop: "0.4rem" }}>
          Proporção recomendada: 3:1. A altura deve ser 1/3 da largura, por
          exemplo 1920x640.
        </span>
        <br />

        <FormLabel>Link</FormLabel>
        <Input
          placeholder="Link"
          value={link}
          onChange={(e) => SetLink(e.target.value)}
        />
      </form>
      <br />
      <div className="w100 inline-flex jcsb mt-2">
        <DefaultButton
          bg="confirm"
          text="Salvar"
          onClick={() => {
            const data = {
              link: link,
              banner: banner,
            };
            OnConfirm(data);
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};
export default Formbody;
